// extracted by mini-css-extract-plugin
module.exports = {"comments":"CommentsSection_comments__ObdY3","commentsTitle":"CommentsSection_commentsTitle__32QBX","commentList":"CommentsSection_commentList__2LyMk"};